<template>
  <div>
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupCheck
          v-if="popup=='check'"
          :text="successText"
          @go="popupAction"
          @cancel="poupupEnter"
        ></PopupCheck>
        <PopupSuccess v-if="popup=='success'" :text="successText" @check="poupupEnter"></PopupSuccess>
        <PopupError v-if="popup=='error'" :text="successText" @check="poupupEnter"></PopupError>
      </Popup>
    </MyTransition>
    <div class="add_course">
      <div class="form_input flex">
        <label>
          教材名稱
          <span class="must">*</span>
        </label>
        <div>
          <input
            type="text"
            placeholder="建立教材名稱"
            class="input_primary"
            v-model="formInput.courseName"
          />
        </div>
      </div>
      <div class="form_input flex">
        <label>
          教材檔案上傳
          <span class="must">*</span>
        </label>
        <div class="img_upload">
          <label for="traning">
            <template v-if="!file.course">
              <i class="el-icon-plus"></i> 點擊上傳
            </template>
            <template v-else>
              {{file.course}}
              <span class="cancel_file" @click.prevent="cancelFile('course')">
                <i class="el-icon-error"></i>
              </span>
            </template>
          </label>
          <!-- <span class="mark">檔案限制5M</span> -->
          <input type="file" id="traning" @change="courseUpload" />
        </div>
      </div>
      <div class="form_input flex">
        <label>
          考試身份
          <span class="must">*</span>
        </label>
        <div class="el_checkbox">
          <el-checkbox-group v-model="formInput.type">
            <el-checkbox label="A">A.工程類人員</el-checkbox>
            <el-checkbox label="B">B.非工程類駐廠人員</el-checkbox>
            <el-checkbox label="C">C.非工程類非駐場人員</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div class="add_course">
      <div class="form_input flex">
        <label>
          考試題目
          <br />
          <span class="mark">可以事後進行編輯</span>
        </label>
        <!--======= 考題======= -->
        <div class="img_upload">
          <!----考試題目列表---->
          <div class="sub_block" v-for="(item,index) in questionList" :key="index">
            <div class="action flex">
              <div @click="del(item,index)">
                <i class="el-icon-delete-solid"></i>
              </div>
            </div>
            <p>
              <textarea class="input_primary" v-model="item.question"></textarea>
            </p>
            <!--判斷編輯--->
            <!--=====正確答案=====-->
            <div class="options answer_block flex">
              正確選項：
              <div class="el_select">
                <el-select v-model="item.correct_answer" placeholder="正確答案">
                  <el-option
                    v-for="item in item.answer_list"
                    :key="item.id"
                    :label="item.answer_item"
                    :value="item.answer_item"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <!--=======錯誤答案========-->
            <div class="options">
              <div v-for="(option,i) in item.answer_list" :key="i" class="flex">
                <div class="options_number">{{option.answer_item}}</div>
                <div class="options_input">
                  <textarea class="input_primary"  v-model="option.answer_text" />
                </div>
              </div>
            </div>
          </div>
          <button class="btn_primary" @click="insertQuestion">新增考題</button>
        </div>
      </div>
    </div>

    <div class="add_course_btn flex">
      <button class="btn_primary" @click="enter">送出資料</button>
      <button class="btn_gray" @click="returnLogin">返回</button>
    </div>
  </div>
</template>
<style lang="scss">
.add_course {
  margin-bottom: 20px;
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  text-align: left;
  .form_input {
    flex-wrap: wrap;
    align-items: baseline;
    // white-space: nowrap;
    label {
      flex: 1.5;
      font-weight: bold;
      span {
        color: var(--subColor);
      }
    }
    > div {
      flex: 8;
      input,
      textarea {
        width: 100%;
      }
    }
    .el_checkbox {
      span {
        color: var(--fontColor);
        font-weight: normal;
      }
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: var(--mainColor);
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: var(--mainColor);
        border-color: var(--mainColor);
      }
    }
  }
  .img_upload {
    margin: 0px 0px;
    img {
      max-width: 100%;
      border: 1px solid #ccc;
      margin: 10px 0 0 0;
    }
    label {
      font-size: 13px;
      border-radius: 5px;
      cursor: pointer;
      border: 1px dashed #ccc;
      display: block;
      text-align: center;
      padding: 10px 50px;
      color: #ccc;
      &:hover {
        border: 1px solid var(--mainColor);
        color: var(--mainColor);
        i {
          color: var(--mainColor);
        }
      }
    }
    > input {
      display: none;
    }
    .sub_block {
      margin: 10px 0 20px 5px;
      padding: 5px 10px;

      border-left: 3px solid var(--mainColor2);
      .action {
        margin-bottom: 10px;
        justify-content: flex-end;
        > div {
          cursor: pointer;
          background: #ccc;
          padding: 4px;
          border-radius: 3px;
          margin: 0 10px 0 0;
          i {
            color: #777;
          }
          &:hover {
            transform: scale(1.1);
            color: #fff;
            background: var(--mainColor);
            i {
              color: #fff;
            }
          }
        }
      }
      p {
        margin-bottom: 20px;
      }
      .options {
        font-size: 13px;
        margin: 8px 0 8px 0;
        align-items: center;
        &.answer_block {
          padding-bottom: 5px;
          border-bottom: 1px dashed #ccc;
        }
        > i {
          font-size: 20px;
        }
        > div {
          margin: 4px 5px;
          border-radius: 5px;
          // color: #fff;
          // padding: 6px 20px 5px 20px;
          align-items: center;
          .options_number {
            padding: 3px 10px;
          }
          .options_input{
            width: 100%;
          }
          &.el_select {
            padding: 0px;
            width: 120px;
            .el-input__inner {
              height: 30px;
            }
          }
        }
      }
    }
    .btn_light {
      color: #444;
      &:hover {
        background: #dfc31d;
      }
    }
  }
  .test_block {
    margin: 20px 0;
    background: #f0f0f0;
    padding: 20px 10px;
    border-radius: 10px;
  }
}
.add_course_btn {
  width: 500px;
  margin: 0 auto;
  button {
    margin: 5px;
  }
}
</style>
<script>
export default {
  name: "add_course",
  data() {
    return {
      formInput: {
        courseName: null,
        type: []
      },
      file: {
        course: null
      },
      questionList: [],
      edit: {
        index: null,
        id: null
      },
      formData: new FormData(),
      popupStatus: false,
      successText: null,
      popup: null,
      post:false
    };
  },
  computed: {
    couserId() {
      return this.$route.query.course_id;
    }
  },
  created() {
    if (this.couserId) {
      this.getData();
    }
  },
  methods: {
    getData() {
      this.$http.api.admin.course(this.couserId).then(res => {
        this.formInput.courseName = res.data[0].course_name;
        this.formInput.type = res.data[0].type;
        this.questionList = res.data[0].question_list;
        this.file.course = res.data[0].course_path;
      });
    },
    courseUpload(e) {
      this.file.course = e.target.files[0].name;
      this.formData.append("course", e.target.files[0]); //放進上傳的檔案
    },
    cancelFile(file) {
      this.file[file] = null;
      this.formData.delete(file);
    },
    del(item, index) {
      this.edit.id = null;
      this.edit.index = index;
      if (item.question_id) {
        this.edit.id = item.question_id;
      }
      this.popupStatus = true;
      this.successText = "確定刪除嗎";
      this.popup = "check";
    },
    enter() {
      this.post=false
      //判斷必填
      this.edit.index = null;
      if (!this.formInput.courseName && !this.file.course) {
        this.popupStatus = true;
        this.popup = "error";
        this.successText = `請填寫所有必填欄位`;
      } else {
        //轉資料格式
        this.formData.append("course_name", this.formInput.courseName);
        this.formData.append("type", JSON.stringify(this.formInput.type));
        this.formData.append(
          "question_list",
          JSON.stringify(this.questionList)
        );
        //分辨是修改還是新增
        if (this.couserId) {
          this.$http.api.admin
            .coursePost(this.formData, this.couserId)
            .then(res => {
              this.popupStatus = true;
              this.successText = "送出成功";
              this.popup = "success";
              this.post=true
            })
            .catch(error => {
              this.popupStatus = true;
              this.popup = "error";
              this.successText = "送出失敗";
            });
        } else {
          this.$http.api.admin
            .coursePost(this.formData)
            .then(res => {
              this.popupStatus = true;
              this.successText = "送出成功";
              this.popup = "success";
              this.post=true
            })
            .catch(error => {
              this.popupStatus = true;
              this.popup = "error";
              this.successText = "送出失敗";
            });
        }
      }
    },
    returnLogin() {
      this.$router.go(-1);
    },
    insertQuestion() {
      let obj = {};
      obj["question"] = null;
      obj["correct_answer"] = null;
      obj["answer_list"] = [
        { answer_item: "A", answer_text: null },
        { answer_item: "B", answer_text: null },
        { answer_item: "C", answer_text: null },
        { answer_item: "D", answer_text: null }
      ];
      this.questionList.push(obj);
    },
    popupAction() {
      if (this.edit.id) {
        this.$http.api.admin.questionDel(this.edit.id).then(res => {
          this.popupStatus = true;
          this.successText = "成功";
          this.popup = "success";
          this.getData()
        }).catch(error=>{
              this.popupStatus = true;
              this.popup = "error";
              this.successText = "失敗";          
        })
      } else {
        this.questionList.splice(this.edit.index, 1);
        this.popupStatus = true;
        this.successText = "成功";
        this.popup = "success";
      }
    },
    poupupEnter() {
      this.popupStatus = false;
      if (this.popup == "success" && this.post) {
        this.returnLogin();
      }
    }
  },
  mounted() {
    // this.getData()
  }
};
</script>